<app-dialog
  id="pin-dialog"
  [title]="'pinConfirmation.title' | translate"
  [isSaving]="isSaving"
  (save)="onSubmit()"
  [confirmation]="'button.submit' | translate"
  [isValid]="formGroup.valid"
>
  <main mat-dialog-content id="pin-dialog-content">
    <h2>{{ heading }}</h2>
    <p [innerHTML]="description"></p>

    <mat-error *ngIf="isError">
      {{ 'pinConfirmation.invalid' | translate }}
    </mat-error>
    <form [formGroup]="formGroup">
      <mat-form-field appearance="outline">
        <input
          matInput
          appAutoFocus
          formControlName="pin"
          pattern="\d*"
          maxlength="4"
          [placeholder]="'pinConfirmation.placeholder' | translate"
          float="never"
          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
          (keyup.enter)="onSubmit()"
          track="Auth, pin_confirmation"
        />
      </mat-form-field>
    </form>
  </main>
  <!-- / content -->
</app-dialog>
<!-- / wrapper -->
